import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {fetchFixedAssetsSettings} from "../../../../_apis/api";
import {setSaveEditFixedAsset} from "../../../../_reducers/activitySlice";
import moment from "moment/moment";
import {percentageTableFormatter} from "./constants";
import {
    defaultEditFixedAssetAdditionalImprovement,
    defaultNewFixedAssetPercTable,
    setEditFixedAsset, setFixedAssetMovementsReportAutoLoad,
} from "../../../../_reducers/DataPanel/FixedAssets/fixedAssetsSlice";
import {
    getDocumentLabel,
    isEmpty,
    startingPeriodOptions
} from "../../../../_helpers/commonFunctions";
import {Button, Col, Row} from "react-bootstrap";
import Dropdown from "../../../primer/Dropdown";
import Input from "../../../common/Input";
import DateBox from "../../../primer/DateBox";
import AccountingBox from "../../../primer/AccountingBox";
import EditableTable from "../../../primer/Editable-Table";
import LogTable from "../../../primer/LogTable";
import FixedAssetBuysCorrelation from "./components/fixed-asset-buys-correlation";
import BetterCheckBox from "../../../common/BetterCheckBox";
import {openFixedAssetMovementsReport} from "../../../../_helpers/tabOpeners";
import FixedAssetSalesCorrelation from "./components/fixed-asset-sales-correlation";
import useInstallationOptions from "../../../../hooks/useInstallationOptions";
import {toast} from "react-toastify";
import TextArea from "../../../common/TextArea";
import {useTranslation} from "../../../../hooks/useTranslation";

const EditFixedAsset = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const saveEditFixedAsset = useSelector((state) => state.ACTIVITY.saveEditFixedAsset);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const fixedAssetsSettings = useSelector((state) => state.FIXED_ASSETS.fixedAssetsSettings);
    const editFixedAsset = useSelector((state) => state.FIXED_ASSETS.editFixedAsset);
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);

    const installationOptions = useInstallationOptions(false);
    const [incrKey2, setIncrKey2] = useState(0);

    useEffect(() => {
        dispatch(fetchFixedAssetsSettings(company.id));
    }, []);

    useEffect(() => {
        setIncrKey2(incrKey2 + 1);
    }, [editFixedAsset?.mydata]);

    const fixedAssetsCategoryOptions = fixedAssetsSettings.categories.map((o) => {
        return {
            value: o._id,
            label: o.name,
            startingPeriod: o.startingPeriod,
        }
    })

    const percentageTableColumns = [
        {
            name: "Ετήσιο % απόσβεσης",
            field: "percentage",
            editable: true,
            required: true,
            inputType: {
                type: 'accounting',
            }
        },
        {
            name: "Ημερομηνία από",
            field: "dateFrom",
            editable: true,
            required: true,
            inputType: {
                type: 'datebox',
                allowOtherYears: "true",
            }
        },
        {
            name: "Ημερομηνία έως",
            field: "dateTo",
            editable: true,
            required: true,
            inputType: {
                type: 'datebox',
                allowOtherYears: "true",
            }
        },
    ]

    const additionalImprovementsColumns = [
        {
            name: "Αρ.",
            field: "no",
            width: "40px",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Τύπος",
            field: "type",
            editable: true,
            width: "15%",
            inputType: {
                type: "select",
                options: [
                    {value: "addition", label: "Προσθήκη"},
                    {value: "improvement", label: "Βελτίωση"},
                ],
            }
        },
        {
            name: "Ημερομηνία",
            field: "date",
            editable: true,
            required: true,
            inputType: {
                type: 'datebox',
                allowOtherYears: "true",
            }
        },
        {
            name: "Περιγραφή",
            field: "description",
            editable: true,
            inputType: {
                type: "input",
            }
        },
        {
            name: "Συσχετιζόμενη Αγορά",
            field: "correlatedBuyLabel",
            editable: false,
            inputType: {
                type: "input",
            }
        },
        {
            name: "Ποσό",
            field: "amount",
            editable: true,
            required: true,
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    allowNegative: true,
                }
            }
        },
        {
            name: "Συμπερίληψη Φ.Π.Α.",
            field: "vatIsIncluded",
            editableCallback: (rowData) => !isEmpty(rowData.correlatedBuyLabel),
            required: true,
            inputType: {
                type: 'checkbox',
            }
        }
    ]

    const myDataColumns = [
        {
            name: t('ProductsNewGeneral.table.rowType'),
            field: "rowType",
            width: "15%",
            editable: true,
            inputType: {
                type: 'select',
                options: [{
                    value: "expense",
                    label: "Έξοδα"
                }]
            }
        },
        {
            name: t('ProductsNewGeneral.table.invoiceType'),
            field: "invoiceType",
            editable: true,
            width: "35%",
            inputType: {
                type: 'select',
                options: [],
            }
        },
        {
            name: t('ProductsNewGeneral.table.category'),
            field: "category",
            editable: true,
            width: "25%",
            inputType: {
                type: 'select',
                options: [],
            }
        },
        {
            name: t('ProductsNewGeneral.table.type'),
            field: 'type',
            editable: true,
            width: "25%",
            inputType: {
                type: 'select',
                options: [],
            }
        },
        /*
        {
            name: t('ProductsNewGeneral.table.vatExpenseType'),
            field: 'vatExpenseType',
            editable: true,
            width: "20%",
            inputType: {
                type: 'select',
                options: getVatExpenseClassificationType(),
            }
        }
         */
    ];

    const handleOnChange = (e, type, name) => {
        if (!saveEditFixedAsset) dispatch(setSaveEditFixedAsset(true));

        const prepChange = {};
        if (type === "dd") {
            prepChange[name] = e.value;
        } else if (type === "datebox") {
            if (moment(e).isValid()) {
                prepChange[name] = moment(e).hour(10);
            } else {
                prepChange[name] = "";
            }
        } else if (type === "input") {
            prepChange[name] = e.target.value;
        } else if (type === "acb") {
            prepChange[name] = e.target.value;
        } else if (type === "cb") {
            prepChange[name] = e.target.checked;
        }
        if (name === "category") {
            prepChange.categoryName = e.label;
            if (editFixedAsset.category !== e.value) {
                const matchingCategory = fixedAssetsSettings.categories.find((el) => el._id === e.value);
                if (matchingCategory) {
                    const asteriskCount = (String(matchingCategory.maskCode).match(/\*/g) || []).length;
                    const num = String(matchingCategory.maskCodeCounter || 1).padStart(asteriskCount, "0");
                    prepChange.systemCode = String(matchingCategory.maskCode).replace(/\*+/g, num);
                    prepChange.startingPeriod = matchingCategory.startingPeriod;
                    prepChange.mydata = matchingCategory?.mydata || [];
                    //assets accounting
                    if (matchingCategory.accounting) prepChange.accounting = matchingCategory.accounting;
                    if (matchingCategory.bypassAccounting) prepChange.bypassAccounting = matchingCategory.bypassAccounting;
                    if (matchingCategory.inverseAccounting) prepChange.inverseAccounting = matchingCategory.inverseAccounting;
                    if (matchingCategory.bypassInverseAccounting) prepChange.bypassInverseAccounting = matchingCategory.bypassInverseAccounting;
                    //sales accounting
                    if (matchingCategory.accountingCodeSales) prepChange.accountingCodeSales = matchingCategory.accountingCodeSales;
                    if (matchingCategory.netAmountAccountingCodeSales) prepChange.netAmountAccountingCodeSales = matchingCategory.netAmountAccountingCodeSales;
                    if (matchingCategory.vatAccountingCodeSales) prepChange.vatAccountingCodeSales = matchingCategory.vatAccountingCodeSales;
                    if (matchingCategory.taxAccountCodeSales) prepChange.taxAccountCodeSales = matchingCategory.taxAccountCodeSales;
                    //buys accounting
                    if (matchingCategory.accountingCodeBuys) prepChange.accountingCodeBuys = matchingCategory.accountingCodeBuys;
                    if (matchingCategory.netAmountAccountingCodeBuys) prepChange.netAmountAccountingCodeBuys = matchingCategory.netAmountAccountingCodeBuys;
                    if (matchingCategory.vatAccountingCodeBuys) prepChange.vatAccountingCodeBuys = matchingCategory.vatAccountingCodeBuys;
                    if (matchingCategory.taxAccountCodeBuys) prepChange.taxAccountCodeBuys = matchingCategory.taxAccountCodeBuys;
                    if (matchingCategory.vatIsIncluded) prepChange.vatIsIncluded = matchingCategory.vatIsIncluded;
                }
            }
        }
        let newOne = {...editFixedAsset, ...prepChange};
        if (["category", "acquisitionCost"].includes(name)) {
            newOne = percentageTableFormatter({...editFixedAsset, ...prepChange}, fixedAssetsSettings);
        }
        dispatch(setEditFixedAsset(newOne));
    }

    const percentageTableFunctions = {
        insert: (e, data) => {
            if (!isEmpty(data.value) && +data.value > 0) {
                if (!saveEditFixedAsset) dispatch(setSaveEditFixedAsset(true));
                const newOne = {...defaultNewFixedAssetPercTable, [data.field] : data.value};
                const clonePercTable = structuredClone(editFixedAsset.percentageTable);
                clonePercTable.push(newOne);
                dispatch(setEditFixedAsset({...editFixedAsset, percentageTable: clonePercTable}));
            }
        },
        update: (data, id, rowIndex) => {
            if (!saveEditFixedAsset) dispatch(setSaveEditFixedAsset(true));
            const clonePercTable = structuredClone(editFixedAsset.percentageTable);
            clonePercTable[rowIndex] = {...clonePercTable[rowIndex], ...data};
            dispatch(setEditFixedAsset({...editFixedAsset, percentageTable: clonePercTable}));
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            if (!saveEditFixedAsset) dispatch(setSaveEditFixedAsset(true));
            const clonePercTable = structuredClone(editFixedAsset.percentageTable);
            clonePercTable.splice(rowIndex, 1);
            dispatch(setEditFixedAsset({...editFixedAsset, percentageTable: clonePercTable}));
        },
    }

    const myDataFunctions = {
        insert: (e, data) => {
            if (!saveEditFixedAsset) dispatch(setSaveEditFixedAsset(true));
            const cloneMD = structuredClone(editFixedAsset.mydata || []);
            const newOne = {
                rowType: "",
                invoiceType: "",
                category: "",
                type: "",
                vatExpenseType: "",
            }
            newOne[data.field] = data.value;
            cloneMD.push(newOne);
            dispatch(setEditFixedAsset({...editFixedAsset, mydata: cloneMD}));
        },
        update: (data, id, rowIndex) => {
            if (!saveEditFixedAsset) dispatch(setSaveEditFixedAsset(true));
            const cloneMD = structuredClone(editFixedAsset.mydata);
            cloneMD[rowIndex] = {...cloneMD[rowIndex], ...data};
            if (data.invoiceType) {
                cloneMD[rowIndex].category = "";
                cloneMD[rowIndex].type = "";
                cloneMD[rowIndex].vatExpenseType = "";
            } else if (data.category) {
                cloneMD[rowIndex].type = "";
                cloneMD[rowIndex].vatExpenseType = "";
            } else if (data.type) {
                cloneMD[rowIndex].vatExpenseType = "";
            }
            dispatch(setEditFixedAsset({...editFixedAsset, mydata: cloneMD}));
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            if (!saveEditFixedAsset) dispatch(setSaveEditFixedAsset(true));
            const cloneMD = structuredClone(editFixedAsset.mydata);
            cloneMD.splice(rowIndex, 1);
            dispatch(setEditFixedAsset({...editFixedAsset, mydata: cloneMD}));
        },
    }

    const additionalImprovementsFunctions = {
        insert: (e, data) => {
            if (!isEmpty(data.value)) {
                if (!saveEditFixedAsset) dispatch(setSaveEditFixedAsset(true));
                const newOne = {...defaultEditFixedAssetAdditionalImprovement, [data.field] : data.value};
                const cloneTable = structuredClone(editFixedAsset.additionalImprovements || []);
                cloneTable.push(newOne);
                cloneTable.forEach((row, idx) => {
                    row.no = String(idx + 1);
                })
                dispatch(setEditFixedAsset({...editFixedAsset, additionalImprovements: cloneTable}));
            }
        },
        update: (data, id, rowIndex) => {
            if (!saveEditFixedAsset) dispatch(setSaveEditFixedAsset(true));
            const cloneTable = structuredClone(editFixedAsset.additionalImprovements);
            cloneTable[rowIndex] = {...cloneTable[rowIndex], ...data};
            cloneTable.forEach((row, idx) => {
                row.no = String(idx + 1);
            })
            dispatch(setEditFixedAsset({...editFixedAsset, additionalImprovements: cloneTable}));
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            if (!saveEditFixedAsset) dispatch(setSaveEditFixedAsset(true));
            const cloneTable = structuredClone(editFixedAsset.additionalImprovements);
            cloneTable.splice(rowIndex, 1);
            cloneTable.forEach((row, idx) => {
                row.no = String(idx + 1);
            })
            dispatch(setEditFixedAsset({...editFixedAsset, additionalImprovements: cloneTable}));
        },
    }

    const handleShowAssetMovements = () => {
        dispatch(setFixedAssetMovementsReportAutoLoad(`${editFixedAsset.name}|${editFixedAsset.systemCode}`));
        openFixedAssetMovementsReport(dispatch, TABS_DATA);
    }

    return (
        <div className={"mb-2"}>
            <Row>
                <Col md={3}>
                    <Dropdown
                        name={"category"}
                        label={"Κατηγορία Παγίου"}
                        options={fixedAssetsCategoryOptions}
                        key={editFixedAsset.category}
                        defaultValue={fixedAssetsCategoryOptions.find((el) => el.value === editFixedAsset.category)}
                        onChange={(e) => handleOnChange(e, "dd", "category")}
                    />
                </Col>
                {editFixedAsset.category && (
                    <React.Fragment>
                        <Col md={3}>
                            <Dropdown
                                name={"startingPeriod"}
                                label={"Περίοδος έναρξης"}
                                options={startingPeriodOptions}
                                key={editFixedAsset.startingPeriod}
                                defaultValue={startingPeriodOptions.find((per) => per.value === editFixedAsset.startingPeriod)}
                                disabled={true}
                            />
                        </Col>
                        <Col md={3}>
                            <div style={{marginTop: "33px"}}>
                                <BetterCheckBox
                                    name={"vatIsIncluded"}
                                    text={"Ο Φ.Π.Α. αποσβένεται"}
                                    checked={String(editFixedAsset.vatIsIncluded) === "true"}
                                    onChange={(e) => handleOnChange(e, "cb", "vatIsIncluded")}
                                />
                            </div>
                        </Col>
                        <Col md={3}>
                            <Button onClick={() => handleShowAssetMovements()} style={{marginTop: "23px"}}>Προβολή καρτέλας παγίου</Button>
                        </Col>
                    </React.Fragment>
                )}
            </Row>
            <Row>
                <Col md={6}>
                    <FixedAssetBuysCorrelation
                        fixedAsset={editFixedAsset}
                        hookCallback={(object, rowNumber) => {
                            if (!saveEditFixedAsset) dispatch(setSaveEditFixedAsset(true));
                            dispatch(setEditFixedAsset({
                                ...editFixedAsset,
                                quantity: object.quantity || 1,
                                correlatedBuy: object._id,
                                correlatedBuyLabel: getDocumentLabel(object),
                                correlatedBuyRowNumber: String(rowNumber),
                                acquisitionCost: +Number(
                                    (editFixedAsset.vatIsIncluded === true ?
                                        object.products.find((el) => String(el.no) === String(rowNumber))?.totalValue
                                        :
                                        object.products.find((el) => String(el.no) === String(rowNumber))?.netValue) || 0,
                                ).toFixed(2)
                            }))
                        }}
                        unHookCallback={() => {
                            if (!saveEditFixedAsset) dispatch(setSaveEditFixedAsset(true));
                            dispatch(setEditFixedAsset({
                                ...editFixedAsset,
                                correlatedBuyHistory: "", // Will be used to refresh buy tab
                                correlatedBuy: "",
                                correlatedBuyLabel: "",
                                correlatedBuyRowNumber: "",
                            }))
                        }}
                    />
                </Col>
                <Col md={6}>
                    <FixedAssetSalesCorrelation
                        fixedAsset={editFixedAsset}
                        unHookCallback={() => {
                            if (!saveEditFixedAsset) dispatch(setSaveEditFixedAsset(true));
                            dispatch(setEditFixedAsset({
                                ...editFixedAsset,
                                correlatedSaleHistory: editFixedAsset.correlatedSale, // Will be used to refresh sale tab
                                correlatedSale: "",
                                correlatedSaleLabel: "",
                                correlatedSaleRowNumber: "",
                            }))
                        }}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={3}>
                    <Input
                        name={"name"}
                        label={"Όνομα παγίου"}
                        required={true}
                        value={editFixedAsset.name}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e, "input", "name")}
                    />
                </Col>
                <Col md={1}>
                    <Input
                        name={"quantity"}
                        label={"Ποσότητα"}
                        value={editFixedAsset.quantity}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e, "input", "quantity")}
                    />
                </Col>
                <Col md={2}>
                    <Input
                        name={"systemCode"}
                        label={"Κωδικός Συστήματος"}
                        value={editFixedAsset.systemCode}
                        autoComplete={"off"}
                        disabled={true}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        name={"manualCode"}
                        label={"Χειροκίνητος Κωδικός"}
                        value={editFixedAsset.manualCode}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e, "input", "manualCode")}
                    />
                </Col>
                <Col md={3}>
                    <Dropdown
                        name={"installation"}
                        label={"Εγκατάσταση"}
                        options={installationOptions}
                        defaultValue={installationOptions.find((el) => el.value === editFixedAsset.installation)}
                        key={editFixedAsset.installation}
                        onChange={(e) => handleOnChange(e, "dd", "installation")}
                    />
                </Col>
            </Row>
            <Row className={"mt-2"}>
                <Col md={3}>
                    <DateBox
                        name={"dateFrom"}
                        label={"Ημερομηνία έναρξης"}
                        allowOtherYears={true}
                        selected={editFixedAsset.dateFrom || null}
                        onChange={(e) => handleOnChange(e, "datebox", "dateFrom")}
                    />
                </Col>
                <Col md={3}>
                    <div className={"mb-1"}>Αξία κτήσης</div>
                    <AccountingBox
                        name={"acquisitionCost"}
                        key={editFixedAsset.acquisitionCost}
                        defaultValue={editFixedAsset.acquisitionCost}
                        onBlur={(e) => handleOnChange(e, "acb", "acquisitionCost")}
                    />
                </Col>
                <Col md={3}>
                    <div className={"mb-1"}>Αποσβεσμένο ποσό</div>
                    <AccountingBox
                        name={"accumulatedDepreciation"}
                        key={editFixedAsset.accumulatedDepreciation}
                        disabled={true}
                        defaultValue={editFixedAsset.accumulatedDepreciation}
                    />
                </Col>
                <Col md={3}>
                    <div className={"mb-1"}>Αναπόσβεστο ποσό / Υπόλοιπο</div>
                    <AccountingBox
                        name={"balance"}
                        key={editFixedAsset.balance}
                        disabled={true}
                        defaultValue={editFixedAsset.balance}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <div className={"text-muted mb-1"}><i>Πίνακας Αποσβέσεων</i></div>
                    <EditableTable
                        tableName={"Fixed Assets Category Percentage Table"}
                        key={Math.random()}
                        columns={percentageTableColumns}
                        onUpdate={percentageTableFunctions}
                        data={editFixedAsset?.percentageTable ? editFixedAsset.percentageTable : []}
                        allowInsertRow={true}
                        allowActions={true}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <div className={"text-muted mb-1"}>
                        <i>Πίνακας Προσθέσεων / Βελτιώσεων</i>
                        <FixedAssetBuysCorrelation
                            fixedAsset={editFixedAsset}
                            hookCallback={(object, rowNumber) => {
                                if (!saveEditFixedAsset) dispatch(setSaveEditFixedAsset(true));

                                const newOne = {
                                    ...defaultEditFixedAssetAdditionalImprovement,
                                    type: "addition",
                                    date: object.date,
                                    description: object.products.find((el) => String(el.no) === String(rowNumber))?.name,
                                    correlatedBuy: object._id,
                                    correlatedBuyLabel: getDocumentLabel(object),
                                    correlatedBuyRowNumber: String(rowNumber),
                                    amount: +Number(
                                        (editFixedAsset.vatIsIncluded === true ?
                                            object.products.find((el) => String(el.no) === String(rowNumber))?.totalValue
                                            :
                                            object.products.find((el) => String(el.no) === String(rowNumber))?.netValue) || 0,
                                    ).toFixed(2),
                                    vatIncluded: !!editFixedAsset.vatIsIncluded,
                                }
                                const cloneTable = structuredClone(editFixedAsset.additionalImprovements || []);
                                if (cloneTable.some((el) => el.correlatedBuy === newOne.correlatedBuy && el.correlatedBuyRowNumber === newOne.correlatedBuyRowNumber)) {
                                    return toast.warning("Έχετε ήδη επιλέξει αυτήν την γραμμή.");
                                }
                                cloneTable.push(newOne);
                                cloneTable.forEach((row, idx) => {
                                    row.no = String(idx + 1);
                                })
                                dispatch(setEditFixedAsset({...editFixedAsset, additionalImprovements: cloneTable}));
                            }}
                            forAdditionalImprovements={true}
                        />
                    </div>
                    <EditableTable
                        tableName={"Edit Fixed Asset Additional Improvements"}
                        key={Math.random()}
                        columns={additionalImprovementsColumns}
                        onUpdate={additionalImprovementsFunctions}
                        data={editFixedAsset?.additionalImprovements ? editFixedAsset.additionalImprovements : []}
                        allowInsertRow={true}
                        allowActions={true}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className="text-muted mb-2"><i>My Data</i></div>
                    <EditableTable
                        tableName="New Fixed Asset My Data"
                        key={"NFAMD" + incrKey2}
                        allowActions={true}
                        onUpdate={myDataFunctions}
                        allowInsertRow={true}
                        columns={myDataColumns}
                        enableNewRowCheckbox={true}
                        data={editFixedAsset.mydata || []}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <TextArea
                        name={"notes"}
                        label={"Παρατηρήσεις / Σημειώσεις"}
                        rows={3}
                        value={editFixedAsset.notes}
                        onChange={(e) => handleOnChange(e, "input", "notes")}
                    />
                </Col>
            </Row>
        </div>
    )
}

export const EditFixedAssetAccounting = () => {
    const dispatch = useDispatch();
    const saveEditFixedAsset = useSelector((state) => state.ACTIVITY.saveEditFixedAsset);
    const editFixedAsset = useSelector((state) => state.FIXED_ASSETS.editFixedAsset);

    const handleOnChange = (e, type, name) => {
        if (!saveEditFixedAsset) dispatch(setSaveEditFixedAsset(true));
        const prepChange = {};
        if (type === "dd") {
            prepChange[name] = e.value;
        } else if (type === "datebox") {
            if (moment(e).isValid()) {
                prepChange[name] = moment(e).hour(10);
            } else {
                prepChange[name] = "";
            }
        } else if (type === "input") {
            prepChange[name] = e.target.value;
        } else if (type === "acb") {
            prepChange[name] = e.target.value;
        } else if (type === "cb") {
            prepChange[name] = e.target.checked;
        }
        let newOne = {...editFixedAsset, ...prepChange};
        dispatch(setEditFixedAsset(newOne));
    }

    return (
        <React.Fragment>
            <p className="text-muted"><i>Ρυθμίσεις Λογιστικής</i></p>
            <div className="text-muted mb-2"><i>Ρυθμίσεις Λογιστικής για Αποσβέσεις - Κινήσεις Παγίων</i></div>
            <Row className={"mb-2"}>
                <Col md={3}>
                    <Input
                        name={"accounting"}
                        label={"Πρόθεμα Λογιστικής Γέφυρας"}
                        value={editFixedAsset?.accounting}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e, "input", "accounting")}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        name={"bypassAccounting"}
                        label={"Κωδικός Παράκαμψης Λογιστικής Γέφυρας"}
                        value={editFixedAsset?.bypassAccounting}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e, "input", "bypassAccounting")}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        name={"inverseAccounting"}
                        label={"Πρόθεμα Αντισυμβαλλόμενου Κωδικού Λογιστικής"}
                        value={editFixedAsset?.inverseAccounting}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e, "input", "inverseAccounting")}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        name={"bypassInverseAccounting"}
                        label={"Αντισυμβαλλόμενος Κωδικός Παράκαμψης Λογιστικής Γέφυρας"}
                        value={editFixedAsset?.bypassInverseAccounting}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e, "input", "bypassInverseAccounting")}
                    />
                </Col>
            </Row>

            <div className="text-muted mb-2"><i>Ρυθμίσεις Λογιστικής για Αγορές Παγίων</i></div>
            <Row className={"mb-2"}>
                <Col md={3}>
                    <Input
                        name={"accountingCodeBuys"}
                        label={"Πρόθεμα Κωδικού Λογαριασμού"}
                        value={editFixedAsset?.accountingCodeBuys}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e, "input", "accountingCodeBuys")}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        name={"netAmountAccountingCodeBuys"}
                        label={"Κωδικός Λογαριασμού Παράκαμψης Καθαρής Αξίας"}
                        value={editFixedAsset?.netAmountAccountingCodeBuys}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e, "input", "netAmountAccountingCodeBuys")}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        name={"vatAccountingCodeBuys"}
                        label={"Κωδικός Λογαριασμού Παράκαμψης ΦΠΑ"}
                        value={editFixedAsset?.vatAccountingCodeBuys}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e, "input", "vatAccountingCodeBuys")}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        name={"taxAccountCodeBuys"}
                        label={"Κωδικός λογαριασμού Παράκαμψης Φόρου"}
                        value={editFixedAsset?.taxAccountCodeBuys}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e, "input", "taxAccountCodeBuys")}
                    />
                </Col>
            </Row>

            <div className="text-muted mb-2"><i>Ρυθμίσεις Λογιστικής για Πωλήσεις Παγίων</i></div>
            <Row className={"mb-2"}>
                <Col md={3}>
                    <Input
                        name={"accountingCodeSales"}
                        label={"Πρόθεμα Κωδικού Λογαριασμού"}
                        value={editFixedAsset?.accountingCodeSales}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e, "input", "accountingCodeSales")}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        name={"netAmountAccountingCodeSales"}
                        label={"Κωδικός Λογαριασμού Παράκαμψης Καθαρής Αξίας"}
                        value={editFixedAsset?.netAmountAccountingCodeSales}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e, "input", "netAmountAccountingCodeSales")}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        name={"vatAccountingCodeSales"}
                        label={"Κωδικός Λογαριασμού Παράκαμψης ΦΠΑ"}
                        value={editFixedAsset?.vatAccountingCodeSales}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e, "input", "vatAccountingCodeSales")}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        name={"taxAccountCodeSales"}
                        label={"Κωδικός λογαριασμού Παράκαμψης Φόρου"}
                        value={editFixedAsset?.taxAccountCodeSales}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e, "input", "taxAccountCodeSales")}
                    />
                </Col>
            </Row>
        </React.Fragment>
    )
}

export const EditFixedAssetLog = () => {
    const editFixedAsset = useSelector((state) => state.FIXED_ASSETS.editFixedAsset);

    return (
        <React.Fragment>
            <div className="text-muted mb-2"><i>Ιστορικό παγίου</i></div>
            <LogTable itemId={editFixedAsset._id}/>
        </React.Fragment>
    )
}

export default EditFixedAsset;
